export const TOURS = [
  {
    id: "gt-classic",
    title: { en: "Golden Triangle Classic", hi: "गोल्डन ट्राइएंगल क्लासिक", es: "Triángulo de Oro Clásico", fr: "Triangle d'Or Classique" },
    route: { en: "Delhi – Agra – Jaipur", hi: "दिल्ली – आगरा – जयपुर", es: "Delhi – Agra – Jaipur", fr: "Delhi – Agra – Jaipur" },
    duration: { en: "5 Days / 4 Nights", hi: "5 दिन / 4 रात", es: "5 Días / 4 Noches", fr: "5 Jours / 4 Nuits" },
    tag: { en: "Best Seller", hi: "बेस्ट सेलर", es: "Más Vendido", fr: "Best-seller" },
    price: null,
    image: "/assets/taj-mahal.jpg",
    highlights: {
      en: ["Sunrise at the Taj Mahal", "Amer Fort & Hawa Mahal", "Qutub Minar, Delhi", "Private chauffeur-driven sedan"],
      hi: ["ताजमहल का सूर्योदय", "आमेर फोर्ट एवं हवा महल", "दिल्ली का कुतुब मीनार", "निजी चालक-युक्त सेडान"],
      es: ["Amanecer en el Taj Mahal", "Fuerte Amber y Hawa Mahal", "Qutub Minar, Delhi", "Sedán privado con chófer"],
      fr: ["Lever de soleil au Taj Mahal", "Fort d'Amber et Hawa Mahal", "Qutub Minar, Delhi", "Berline privée avec chauffeur"],
    },
  },
  {
    id: "gt-express",
    title: { en: "Golden Triangle Express", hi: "गोल्डन ट्राइएंगल एक्सप्रेस", es: "Triángulo de Oro Exprés", fr: "Triangle d'Or Express" },
    route: { en: "Delhi – Agra – Jaipur", hi: "दिल्ली – आगरा – जयपुर", es: "Delhi – Agra – Jaipur", fr: "Delhi – Agra – Jaipur" },
    duration: { en: "4 Days / 3 Nights", hi: "4 दिन / 3 रात", es: "4 Días / 3 Noches", fr: "4 Jours / 3 Nuits" },
    tag: { en: "Popular", hi: "लोकप्रिय", es: "Popular", fr: "Populaire" },
    price: null,
    image: "https://images.unsplash.com/photo-1713682995521-22ec819b50ac?crop=entropy&cs=srgb&fm=jpg&ixid=M3w3NDk1ODF8MHwxfHNlYXJjaHwyfHxyYWphc3RoYW4lMjBwYWxhY2UlMjBmb3J0JTIwZXZlbmluZyUyMGxpZ2h0c3xlbnwwfHx8fDE3OTIxNjAwMDB8MA&ixlib=rb-4.1.0&q=85",
    highlights: {
      en: ["Fast-track monument access", "Gatimaan Express train option", "Private cab & guide"],
      hi: ["फास्ट-ट्रैक स्मारक प्रवेश", "गतिमान एक्सप्रेस ट्रेन विकल्प", "निजी कैब एवं गाइड"],
      es: ["Acceso rápido a monumentos", "Opción de tren Gatimaan Express", "Coche privado y guía"],
      fr: ["Accès prioritaire aux monuments", "Option train Gatimaan Express", "Voiture privée et guide"],
    },
  },
  {
    id: "gt-luxury",
    title: { en: "Golden Triangle Royal Luxury", hi: "गोल्डन ट्राइएंगल रॉयल लक्ज़री", es: "Triángulo de Oro Lujo Real", fr: "Triangle d'Or Luxe Royal" },
    route: { en: "Delhi – Agra – Jaipur", hi: "दिल्ली – आगरा – जयपुर", es: "Delhi – Agra – Jaipur", fr: "Delhi – Agra – Jaipur" },
    duration: { en: "6 Days / 5 Nights", hi: "6 दिन / 5 रात", es: "6 Días / 5 Noches", fr: "6 Jours / 5 Nuits" },
    tag: { en: "Signature", hi: "सिग्नेचर", es: "Signature", fr: "Signature" },
    price: null,
    image: "https://images.unsplash.com/photo-1785785209950-60289e2bfbb2?crop=entropy&cs=srgb&fm=jpg&ixid=M3w3NDk1ODF8MHwxfHNlYXJjaHw0fHxyYWphc3RoYW4lMjBwYWxhY2UlMjBmb3J0JTIwZXZlbmluZyUyMGxpZ2h0c3xlbnwwfHx8fDE3OTIxNjAwMDB8MA&ixlib=rb-4.1.0&q=85",
    highlights: {
      en: ["Palace & 5-star heritage stays", "Vintage car transfers", "Private high tea experiences"],
      hi: ["महल एवं 5-स्टार हेरिटेज स्टे", "विंटेज कार ट्रांसफर", "निजी हाई-टी अनुभव"],
      es: ["Estancias en palacios y hoteles 5 estrellas", "Traslados en coche clásico", "Experiencias privadas de high tea"],
      fr: ["Séjours en palais et hôtels 5 étoiles", "Transferts en voiture de collection", "Expériences de high tea privées"],
    },
  },
  {
    id: "gt-varanasi",
    title: { en: "Golden Triangle with Sacred Varanasi", hi: "पवित्र वाराणसी सहित गोल्डन ट्राइएंगल", es: "Triángulo de Oro con Varanasi Sagrada", fr: "Triangle d'Or avec Bénarès Sacrée" },
    route: { en: "Delhi – Agra – Jaipur – Varanasi", hi: "दिल्ली – आगरा – जयपुर – वाराणसी", es: "Delhi – Agra – Jaipur – Varanasi", fr: "Delhi – Agra – Jaipur – Bénarès" },
    duration: { en: "7 Days / 6 Nights", hi: "7 दिन / 6 रात", es: "7 Días / 6 Noches", fr: "7 Jours / 6 Nuits" },
    tag: { en: "Spiritual Focus", hi: "आध्यात्मिक", es: "Enfoque Espiritual", fr: "Spirituel" },
    price: null,
    image: "https://images.unsplash.com/photo-1705952484283-19c31e37e0e4?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NjY2NzV8MHwxfHNlYXJjaHwxfHx2YXJhbmFzaSUyMGdoYXRzJTIwZXZlbmluZyUyMGFhcnRpJTIwcml2ZXIlMjBHYW5nZXN8ZW58MHx8fHwxNzkyMTYwMDA2fDA&ixlib=rb-4.1.0&q=85",
    highlights: {
      en: ["Evening Ganga Aarti by boat", "Sarnath ancient stupas", "Silk weaving heritage tour"],
      hi: ["नौका से संध्या गंगा आरती", "सारनाथ के प्राचीन स्तूप", "रेशम बुनाई विरासत टूर"],
      es: ["Ganga Aarti nocturna en barco", "Estupas antiguas de Sarnath", "Tour del tejido de seda"],
      fr: ["Ganga Aarti du soir en bateau", "Stupas antiques de Sarnath", "Visite du tissage de la soie"],
    },
  },
  {
    id: "holi-festival",
    title: { en: "Holi Sacred Festival Experience", hi: "होली पवित्र महोत्सव अनुभव", es: "Experiencia del Festival Sagrado de Holi", fr: "Expérience du Festival Sacré de Holi" },
    route: { en: "Mathura – Vrindavan – Agra", hi: "मथुरा – वृंदावन – आगरा", es: "Mathura – Vrindavan – Agra", fr: "Mathura – Vrindavan – Agra" },
    duration: { en: "4 Days / 3 Nights", hi: "4 दिन / 3 रात", es: "4 Días / 3 Noches", fr: "4 Jours / 3 Nuits" },
    tag: { en: "Seasonal Special", hi: "मौसमी विशेष", es: "Especial de Temporada", fr: "Spécial Saison" },
    price: null,
    image: "https://images.pexels.com/photos/31836726/pexels-photo-31836726.jpeg?auto=compress&cs=tinysrgb&dpr=2&h=650&w=940",
    highlights: {
      en: ["Legendary Braj Holi celebrations", "VIP temple access", "Traditional festive feast"],
      hi: ["प्रसिद्ध ब्रज होली उत्सव", "वीआईपी मंदिर प्रवेश", "पारंपरिक उत्सव भोज"],
      es: ["Legendarias celebraciones de Holi en Braj", "Acceso VIP a templos", "Banquete festivo tradicional"],
      fr: ["Légendaires célébrations de Holi à Braj", "Accès VIP aux temples", "Festin traditionnel"],
    },
  },
  {
    id: "diwali-cultural",
    title: { en: "Diwali Cultural Royal Expedition", hi: "दिवाली सांस्कृतिक शाही अभियान", es: "Expedición Real Cultural de Diwali", fr: "Expédition Royale Culturelle de Diwali" },
    route: { en: "Jaipur – Delhi", hi: "जयपुर – दिल्ली", es: "Jaipur – Delhi", fr: "Jaipur – Delhi" },
    duration: { en: "4 Days / 3 Nights", hi: "4 दिन / 3 रात", es: "4 Días / 3 Noches", fr: "4 Jours / 3 Nuits" },
    tag: { en: "Cultural Elite", hi: "सांस्कृतिक विशेष", es: "Élite Cultural", fr: "Élite Culturelle" },
    price: null,
    image: "https://images.unsplash.com/photo-1673115955483-6c9e461e8a7b?crop=entropy&cs=srgb&fm=jpg&ixid=M3w3NDk1ODF8MHwxfHNlYXJjaHwzfHxyYWphc3RoYW4lMjBwYWxhY2UlMjBmb3J0JTIwZXZlbmluZyUyMGxpZ2h0c3xlbnwwfHx8fDE3OTIxNjAwMDB8MA&ixlib=rb-4.1.0&q=85",
    highlights: {
      en: ["Palace illumination dinner", "Diya lighting ceremony", "Old Delhi bazaar walk"],
      hi: ["महल जगमगाहट भोज", "दीप प्रज्वलन समारोह", "पुरानी दिल्ली बाज़ार भ्रमण"],
      es: ["Cena en palacio iluminado", "Ceremonia de encendido de diyas", "Paseo por el bazar del Viejo Delhi"],
      fr: ["Dîner au palais illuminé", "Cérémonie d'allumage des diyas", "Balade au bazar du Vieux Delhi"],
    },
  },
  {
    id: "pushkar-fair",
    title: { en: "Pushkar Camel Fair & Desert Odyssey", hi: "पुष्कर ऊंट मेला एवं रेगिस्तान यात्रा", es: "Feria de los Camellos de Pushkar y Odisea del Desierto", fr: "Foire aux Chameaux de Pushkar & Odyssée du Désert" },
    route: { en: "Pushkar – Ajmer", hi: "पुष्कर – अजमेर", es: "Pushkar – Ajmer", fr: "Pushkar – Ajmer" },
    duration: { en: "4 Days / 3 Nights", hi: "4 दिन / 3 रात", es: "4 Días / 3 Noches", fr: "4 Jours / 3 Nuits" },
    tag: { en: "Heritage Event", hi: "विरासत आयोजन", es: "Evento Patrimonial", fr: "Événement Patrimoine" },
    price: null,
    image: "/assets/brahma-temple-pushkar.jpg",
    highlights: {
      en: ["Brahma Temple darshan", "Royal desert tent stay", "Camel safari at sunset"],
      hi: ["ब्रह्मा मंदिर दर्शन", "शाही रेगिस्तानी तंबू स्टे", "सूर्यास्त पर ऊंट सफारी"],
      es: ["Darshan en el Templo de Brahma", "Estancia en tienda real del desierto", "Safari en camello al atardecer"],
      fr: ["Darshan au Temple de Brahma", "Nuit en tente royale du désert", "Safari à dos de chameau au coucher du soleil"],
    },
  },
  {
    id: "photo-expedition",
    title: { en: "Master Photography Tour", hi: "मास्टर फोटोग्राफी टूर", es: "Tour Maestro de Fotografía", fr: "Circuit Photo d'Exception" },
    route: { en: "Rajasthan or Himalayan Foothills", hi: "राजस्थान या हिमालय की तलहटी", es: "Rajastán o Estribaciones del Himalaya", fr: "Rajasthan ou Piémont de l'Himalaya" },
    duration: { en: "5–8 Days, Customizable", hi: "5–8 दिन, अनुकूलन योग्य", es: "5–8 Días, Personalizable", fr: "5–8 Jours, Personnalisable" },
    tag: { en: "Specialized", hi: "विशेषज्ञ", es: "Especializado", fr: "Spécialisé" },
    price: null,
    image: "https://images.pexels.com/photos/19195973/pexels-photo-19195973.jpeg?auto=compress&cs=tinysrgb&dpr=2&h=650&w=940",
    highlights: {
      en: ["Golden-hour fort shoots", "Portrait sessions with artisans", "Curated route by experts"],
      hi: ["गोल्डन-अवर किला शूट", "कारीगरों के साथ पोर्ट्रेट सत्र", "विशेषज्ञों द्वारा चयनित मार्ग"],
      es: ["Sesiones en fuertes a la hora dorada", "Retratos con artesanos locales", "Ruta seleccionada por expertos"],
      fr: ["Shootings aux forts à l'heure dorée", "Portraits avec artisans locaux", "Itinéraire conçu par des experts"],
    },
  },
  {
    id: "shopping-handicraft",
    title: { en: "Shopping & Imperial Handicraft Circuit", hi: "शॉपिंग एवं शाही हस्तशिल्प सर्किट", es: "Circuito de Compras y Artesanía Imperial", fr: "Circuit Shopping & Artisanat Impérial" },
    route: { en: "Jaipur – Delhi – Agra", hi: "जयपुर – दिल्ली – आगरा", es: "Jaipur – Delhi – Agra", fr: "Jaipur – Delhi – Agra" },
    duration: { en: "5 Days / 4 Nights", hi: "5 दिन / 4 रात", es: "5 Días / 4 Noches", fr: "5 Jours / 4 Nuits" },
    tag: { en: "Exclusive Access", hi: "विशेष पहुँच", es: "Acceso Exclusivo", fr: "Accès Exclusif" },
    price: null,
    image: "https://images.pexels.com/photos/33658452/pexels-photo-33658452.jpeg?auto=compress&cs=tinysrgb&dpr=2&h=650&w=940",
    highlights: {
      en: ["Blue pottery & block printing studios", "Zardozi embroidery masters", "Private shipping concierge"],
      hi: ["ब्लू पॉटरी एवं ब्लॉक प्रिंटिंग स्टूडियो", "ज़रदोज़ी कढ़ाई उस्ताद", "निजी शिपिंग कंसीयज"],
      es: ["Talleres de cerámica azul y block printing", "Maestros del bordado zardozi", "Conserjería privada de envíos"],
      fr: ["Ateliers de poterie bleue et block print", "Maîtres de la broderie zardozi", "Conciergerie d'expédition privée"],
    },
  },
  {
    id: "architecture-imperial",
    title: { en: "Imperial Architectural Heritage Tour", hi: "शाही स्थापत्य विरासत टूर", es: "Tour del Patrimonio Arquitectónico Imperial", fr: "Circuit du Patrimoine Architectural Impérial" },
    route: { en: "Delhi – Agra – Khajuraho", hi: "दिल्ली – आगरा – खजुराहो", es: "Delhi – Agra – Khajuraho", fr: "Delhi – Agra – Khajuraho" },
    duration: { en: "7 Days / 6 Nights", hi: "7 दिन / 6 रात", es: "7 Días / 6 Noches", fr: "7 Jours / 6 Nuits" },
    tag: { en: "In-Depth Study", hi: "गहन अध्ययन", es: "Estudio en Profundidad", fr: "Étude Approfondie" },
    price: null,
    image: "/assets/khajuraho.jpg",
    highlights: {
      en: ["UNESCO sites with expert guides", "Khajuraho stone carvings", "Mughal & Chandela architecture"],
      hi: ["विशेषज्ञ गाइड के साथ यूनेस्को स्थल", "खजुराहो की पाषाण नक्काशी", "मुगल एवं चंदेल स्थापत्य"],
      es: ["Sitios UNESCO con guías expertos", "Tallas de piedra de Khajuraho", "Arquitectura mogol y Chandela"],
      fr: ["Sites UNESCO avec guides experts", "Sculptures de pierre de Khajuraho", "Architecture moghole et Chandela"],
    },
  },
];

export const GALLERY = [
  { src: "/assets/taj-mahal.jpg", name: { en: "Taj Mahal", hi: "ताजमहल", es: "Taj Mahal", fr: "Taj Mahal" }, place: { en: "Agra", hi: "आगरा", es: "Agra", fr: "Agra" } },
  { src: "/assets/amer-fort.jpg", name: { en: "Amer Fort", hi: "आमेर फोर्ट", es: "Fuerte Amber", fr: "Fort d'Amber" }, place: { en: "Jaipur", hi: "जयपुर", es: "Jaipur", fr: "Jaipur" } },
  { src: "/assets/qutub-minar.jpg", name: { en: "Qutub Minar", hi: "कुतुब मीनार", es: "Qutub Minar", fr: "Qutub Minar" }, place: { en: "Delhi", hi: "दिल्ली", es: "Delhi", fr: "Delhi" } },
  { src: "/assets/khajuraho.jpg", name: { en: "Khajuraho Temples", hi: "खजुराहो के मंदिर", es: "Templos de Khajuraho", fr: "Temples de Khajuraho" }, place: { en: "Khajuraho", hi: "खजुराहो", es: "Khajuraho", fr: "Khajuraho" } },
  { src: "/assets/brahma-temple-pushkar.jpg", name: { en: "Brahma Temple", hi: "ब्रह्मा मंदिर", es: "Templo de Brahma", fr: "Temple de Brahma" }, place: { en: "Pushkar", hi: "पुष्कर", es: "Pushkar", fr: "Pushkar" } },
  { src: "/assets/mehrangarh-fort.jpg", name: { en: "Mehrangarh Fort", hi: "मेहरानगढ़ फोर्ट", es: "Fuerte Mehrangarh", fr: "Fort Mehrangarh" }, place: { en: "Jodhpur", hi: "जोधपुर", es: "Jodhpur", fr: "Jodhpur" } },
  { src: "/assets/udaipur-lake.jpg", name: { en: "Lakes of Udaipur", hi: "उदयपुर की झीलें", es: "Lagos de Udaipur", fr: "Lacs d'Udaipur" }, place: { en: "Udaipur", hi: "उदयपुर", es: "Udaipur", fr: "Udaipur" } },
];

export const COLLECTION_IMAGES = [
  "/assets/mehrangarh-fort.jpg",
  "/assets/udaipur-lake.jpg",
  "/assets/taj-mahal.jpg",
  "/assets/brahma-temple-pushkar.jpg",
];
